import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { Typography } from '@cfa/react-components';

import { currentYear, formatDateAsUtc } from '@/utils/date';
import { cn } from '@/utils/tailwind';

import BreadcrumbLinks from '@/components/BreadcrumbLinks/BreadcrumbLinks';

import { Breadcrumb } from '@/types/types';

interface CopyrightFooterProps {
  lastPublishedDate: string;
  breadcrumbs: Breadcrumb[];
  isTraining: boolean;
}

export const CopyrightFooter: FC<CopyrightFooterProps> = ({
  lastPublishedDate,
  breadcrumbs,
  isTraining,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      className={cn(
        'mx-auto my-12 flex max-w-full flex-col items-center justify-center gap-8 px-5 md:max-w-[652px] md:px-10',
        {
          'mx-auto mt-0 mb-12': isTraining,
        },
      )}
    >
      <BreadcrumbLinks breadcrumbs={breadcrumbs} />
      <Typography variant="body2" className="mt-[48px]">
        {t('Generic.documentFooter', {
          currentYear,
          lastPublishedDate: lastPublishedDate
            ? formatDateAsUtc(lastPublishedDate, i18n.language)
            : null,
        })}
      </Typography>
    </div>
  );
};
